import { render, staticRenderFns } from "./DateInput.vue?vue&type=template&id=515fc82a&scoped=true"
import script from "./DateInput.vue?vue&type=script&lang=js"
export * from "./DateInput.vue?vue&type=script&lang=js"
import style0 from "./DateInput.vue?vue&type=style&index=0&id=515fc82a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../animod-voucherportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515fc82a",
  null
  
)

export default component.exports